module.exports = __webpack_public_path__ + "static/media/logo.cb4f3fce.svg";